var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "选择店铺",
        visible: _vm.visible,
        width: "800px",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": "",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading.fullscreen.lock",
              value: _vm.loading,
              expression: "loading",
              modifiers: { fullscreen: true, lock: true },
            },
          ],
          attrs: {
            "element-loading-text": "正在加载数据",
            "element-loading-background": "rgba(255, 255, 255, 0)",
          },
        },
        [
          _c(
            "div",
            { staticClass: "mb20" },
            [
              _c("el-input", {
                staticStyle: { width: "352px", "margin-right": "10px" },
                attrs: {
                  placeholder: "请输入竞争对手店铺内任意一条产品地址或旺旺ID",
                  size: "medium",
                },
                model: {
                  value: _vm.keyword,
                  callback: function ($$v) {
                    _vm.keyword = $$v
                  },
                  expression: "keyword",
                },
              }),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "medium" },
                  on: { click: _vm.addShop },
                },
                [_vm._v("添加")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.shopList,
                stripe: "",
                "header-cell-style": _vm.tableHeader,
              },
            },
            [
              _c("div", { attrs: { slot: "empty" }, slot: "empty" }, [
                !_vm.loading && _vm.shopList.length === 0
                  ? _c("span", [_vm._v("暂无数据")])
                  : _vm._e(),
              ]),
              _c("el-table-column", {
                attrs: {
                  prop: "WangWang",
                  label: "旺旺",
                  align: "center",
                  "header-align": "center",
                  width: "118",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "CompanyName",
                  label: "公司名称",
                  align: "center",
                  "header-align": "center",
                  width: "198",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  "header-align": "center",
                  label: "店铺地址",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "a",
                          {
                            staticStyle: { color: "#0064c1" },
                            attrs: { href: row.ShopUrl, target: "_blank" },
                          },
                          [_vm._v(_vm._s(row.ShopUrl))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  "header-align": "center",
                  label: "操作",
                  width: "165",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.selectShop(row)
                              },
                            },
                          },
                          [_vm._v("选择")]
                        ),
                        row.showDelBtn
                          ? _c(
                              "el-link",
                              {
                                staticStyle: { "margin-left": "20px" },
                                attrs: { type: "info" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteShop(row)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            staticStyle: { "text-align": "center", padding: "10px 0" },
            attrs: {
              background: "",
              "current-page": _vm.query.index,
              "page-size": _vm.query.size,
              layout: "prev, pager, next, total, jumper",
              total: _vm.query.total,
            },
            on: { "current-change": _vm.handleCurrentChange },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }